// Najwięcej obserwowanych ogłoszeń na konto. Konta, które mają więcej, zachowują obserwacje, ale nie dodadzą nowych.
export const WATCH_LIMIT = 300
